import { Invite } from '@prisma/client';
import { InviteCreateInput, InviteDeleteInput, InviteUpdateInput } from '@/models/schema';
import { handleNetworkError } from '@/lib/api/global';

export const addInvite = async (inviteInput: InviteCreateInput) => {
  const response = await fetch(`/api/schedules/${inviteInput.scheduleId}/invites`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...inviteInput }),
  });

  if (!response.ok) {
    handleNetworkError('Failed to create invite');
  }
};

export const deleteInvite = async (scheduleId: string, inviteId: string) => {
  const inviteInput = {
    inviteId,
  } as InviteDeleteInput;

  const response = await fetch(`/api/schedules/${scheduleId}/invites/${inviteId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...inviteInput }),
  });

  if (!response.ok) {
    handleNetworkError('Failed to delete invite');
  }

  return (await response.json()) as Invite;
};

export const updateInvite = async (scheduleId: string, inviteId: string, role: InviteUpdateInput['role']) => {
  const inviteInput = {
    inviteId,
    role,
  } as InviteUpdateInput;

  const response = await fetch(`/api/schedules/${scheduleId}/invites/${inviteId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...inviteInput }),
  });

  if (!response.ok) {
    handleNetworkError('Failed to update invite');
  }

  return (await response.json()) as Invite;
};
